export interface ConfigWithErrors<C> {
  config: C
  errors?: string[]
}

export function extractErrors<C>({ config, errors }: ConfigWithErrors<C>, errorsSink?: string[]): C {
  if (errors && errorsSink) {
    errorsSink.push(...errors)
  }
  return config
}
